module.exports = __webpack_public_path__ + "static/media/U1_ROUGH.4a77aaba.png";